import { render, staticRenderFns } from "./GuestCard.vue?vue&type=template&id=08da3154&"
import script from "./GuestCard.vue?vue&type=script&lang=js&"
export * from "./GuestCard.vue?vue&type=script&lang=js&"
import style0 from "./GuestCard.vue?vue&type=style&index=0&id=08da3154&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports